import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { MapPin, Clock } from "lucide-react";
import Section from "../ui/Section";
import InfoCard from "../ui/InfoCard";

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Section id="about" background="dark">
      <div className="text-center mb-12">
        <h2 className="headline mb-6">{t("about.title")}</h2>
        <p className="section-description mx-auto">{t("about.description")}</p>
      </div>
      <div className="relative">
        <div className="flex items-center justify-between gap-5 max-w-[600px] mx-auto">
          <InfoCard
            title={t("about.info.location.title")}
            description={t("about.info.location.description")}
            variant="default"
            className="w-full"
          />
          <InfoCard
            title={t("about.info.experience.title")}
            description={t("about.info.experience.description")}
            variant="default"
            className="w-full"
          />
        </div>
      </div>
    </Section>
  );
};

export default About;
